import { useState } from 'react';
import Reveal from './Reveal';
import { faqs } from '../content';

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="scroll-mt-24 bg-[#FBF9F4] py-16 md:py-24">
      <div className="mx-auto grid max-w-[1200px] grid-cols-1 gap-10 px-4 md:px-6 lg:grid-cols-[0.42fr_1fr] lg:gap-16">
        <Reveal>
          <div className="lg:sticky lg:top-28">
            <span className="inline-flex items-center gap-2 rounded-full border border-rose-500/20 bg-rose-50 px-3 py-1 text-xs text-rose-600">
              <i className="ri-question-line text-sm"></i>
              常见问题解答
            </span>
            <h2 className="mt-4 text-2xl font-bold tracking-tight text-stone-900 md:text-4xl">还有疑问？</h2>
            <p className="mt-4 text-sm leading-7 text-stone-500 md:text-[15px]">
              我们把新手最容易问到的几个问题整理在这里。没找到答案的话，也欢迎直接联系我们。
            </p>

            <div className="mt-8 rounded-2xl border border-black/5 bg-emerald-600 p-6 text-white">
              <p className="text-sm font-medium">需要更多帮助？</p>
              <p className="mt-1.5 text-xs leading-6 text-white/80">
                在软件内「我的 — 帮助与反馈」留言，或通过下方联系方式找到我们，通常 1–2 个工作日回复。
              </p>
              <a
                href="#footer"
                className="mt-4 inline-flex items-center gap-1.5 text-sm font-medium text-white underline decoration-white/40 underline-offset-4 transition-colors hover:decoration-white"
              >
                查看联系方式 <i className="ri-arrow-right-line text-base"></i>
              </a>
            </div>
          </div>
        </Reveal>

        <div className="flex flex-col">
          {faqs.map((item, i) => {
            const open = openIndex === i;
            return (
              <Reveal key={item.q} delay={i * 60}>
                <div className="border-b border-black/10">
                  <button
                    type="button"
                    onClick={() => setOpenIndex(open ? null : i)}
                    className="flex w-full items-center justify-between gap-4 py-5 text-left"
                    aria-expanded={open}
                  >
                    <span className="text-[15px] font-semibold text-stone-900">{item.q}</span>
                    <span
                      className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full transition-all duration-300 ${
                        open ? 'bg-emerald-600 text-white' : 'bg-stone-200 text-stone-600'
                      }`}
                    >
                      <i className={`${open ? 'ri-subtract-line' : 'ri-add-line'} text-base`}></i>
                    </span>
                  </button>
                  <div
                    className="grid transition-all duration-300 ease-out"
                    style={{ gridTemplateRows: open ? '1fr' : '0fr' }}
                  >
                    <div className="overflow-hidden">
                      <p className="pb-6 pr-10 text-sm leading-7 text-stone-500">{item.a}</p>
                    </div>
                  </div>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}